import { render, staticRenderFns } from "./SwapSelectToken.vue?vue&type=template&id=603e8b02&scoped=true"
import script from "./SwapSelectToken.vue?vue&type=script&lang=ts"
export * from "./SwapSelectToken.vue?vue&type=script&lang=ts"
import style0 from "./SwapSelectToken.vue?vue&type=style&index=0&id=603e8b02&prod&lang=scss&scoped=true"
import style1 from "./SwapSelectToken.vue?vue&type=style&index=1&id=603e8b02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603e8b02",
  null
  
)

export default component.exports